import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

import "../../hamcss/lifeAtSG.css";
// import the local image as a module
import christmasImg1 from "../../assests/lifeAtSG/Christmas/1.webp";
import christmasImg2 from "../../assests/lifeAtSG/Christmas/2.webp";
import christmasImg3 from "../../assests/lifeAtSG/Christmas/3.webp";
import christmasImg4 from "../../assests/lifeAtSG/Christmas/4.jpg";
import christmasImg5 from "../../assests/lifeAtSG/Christmas/5.webp";
import christmasImg6 from "../../assests/lifeAtSG/Christmas/6.jpg";
import holi1 from "../../assests/lifeAtSG/holi/1.webp";
import holi2 from "../../assests/lifeAtSG/holi/2.webp";
import holi3 from "../../assests/lifeAtSG/holi/3.webp";
import holi4 from "../../assests/lifeAtSG/holi/4.webp";
import holi5 from "../../assests/lifeAtSG/holi/IMG_1580.webp";
import diwali1 from "../../assests/lifeAtSG/diwali/1.webp";
import diwali2 from "../../assests/lifeAtSG/diwali/5.webp";
import diwali3 from "../../assests/lifeAtSG/diwali/3.webp";
import diwali4 from "../../assests/lifeAtSG/diwali/4.webp";
import diwali5 from "../../assests/lifeAtSG/diwali/IMG_9092.jpg";
import diwali6 from "../../assests/lifeAtSG/diwali/IMG_6140.jpg";
import diwali7 from "../../assests/lifeAtSG/diwali/IMG_6141.jpg";
import meeting1 from "../../assests/lifeAtSG/meetings/1.webp";
import meeting2 from "../../assests/lifeAtSG/meetings/2.webp";
import meeting3 from "../../assests/lifeAtSG/meetings/3.webp";
import meeting4 from "../../assests/lifeAtSG/meetings/4.webp";

const LifeAtSG = () => {

const lifeImages = [
"https://sgfinserve.com/sg_files/life_at_sg_images/31.jpeg",
"https://sgfinserve.com/sg_files/life_at_sg_images/32.jpg",
"https://sgfinserve.com/sg_files/life_at_sg_images/33.jpg",
"https://sgfinserve.com/sg_files/life_at_sg_images/34.jpeg",
"https://sgfinserve.com/sg_files/life_at_sg_images/35.jpeg",
"https://sgfinserve.com/sg_files/life_at_sg_images/36.jpeg",
"https://sgfinserve.com/sg_files/life_at_sg_images/37.jpg",
"https://sgfinserve.com/sg_files/life_at_sg_images/38.jpg",
"https://sgfinserve.com/sg_files/life_at_sg_images/39.jpg",
"https://sgfinserve.com/sg_files/life_at_sg_images/40.jpg",
"https://sgfinserve.com/sg_files/life_at_sg_images/21.jpeg",
"https://sgfinserve.com/sg_files/life_at_sg_images/22.jpeg",
"https://sgfinserve.com/sg_files/life_at_sg_images/23.jpeg",
"https://sgfinserve.com/sg_files/life_at_sg_images/24.jpeg",
"https://sgfinserve.com/sg_files/life_at_sg_images/25.jpeg",
"https://sgfinserve.com/sg_files/life_at_sg_images/26.jpeg",
"https://sgfinserve.com/sg_files/life_at_sg_images/27.jpeg",
"https://sgfinserve.com/sg_files/life_at_sg_images/28.jpeg",
"https://sgfinserve.com/sg_files/life_at_sg_images/29.jpeg",
"https://sgfinserve.com/sg_files/life_at_sg_images/30.jpeg",
"https://sgfinserve.com/sg_files/life_at_sg_images/women1.JPG",
"https://sgfinserve.com/sg_files/life_at_sg_images/women2.JPG",
"https://sgfinserve.com/sg_files/life_at_sg_images/women3.JPG",
"https://sgfinserve.com/sg_files/life_at_sg_images/women4.JPG",
"https://sgfinserve.com/sg_files/life_at_sg_images/women5.JPG",
"https://sgfinserve.com/sg_files/life_at_sg_images/women6.JPG",
christmasImg1,
christmasImg2,
christmasImg3,
christmasImg4,
christmasImg5,
christmasImg6,
holi1,
holi2,
holi3,
holi4,
holi5,
diwali1,
diwali2,
diwali3,
diwali4,
diwali5,
diwali6,
diwali7,
meeting1,
meeting2,
meeting3,
meeting4,
];



// split images into groups of 8
const slides = [];
for (let i = 0; i < lifeImages.length; i += 8) {
  slides.push(lifeImages.slice(i, i + 8));
}

return (
<section className="life-main">

<div className="life-heading">
<h2 className="h2-text-new-board">Life at SG</h2>
<p className="p-text-new-para">
A glimpse into our vibrant workplace culture, teamwork, and everyday moments
that make SG Finserve a great place to grow.
</p>
</div>

<div className="life-gallery">

<Swiper
slidesPerView={1}
spaceBetween={30}
pagination={{ clickable: true }}
modules={[Pagination]}
>

{slides.map((group, index) => (
<SwiperSlide key={index}>

<div className="life-grid">

{group.map((img, i) => (
<div className="life-img-box" key={i}>
<img src={img} alt="Life at SG" />
</div>
))}

</div>

</SwiperSlide>
))}

</Swiper>

</div>
</section>
);
};

export default LifeAtSG;